import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { HubEndpoint } from '../../hub/constants/hub-endpoint';
import { CompartmentEndpoint } from '../constants/compartment-endpoint';
import { CompartmentOverview } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CompartmentItemService {
  constructor(private http: WrapperHttpService) {}

  createNewCompartment({
    hubId,
    compartmentOverview,
  }: {
    hubId: number;
    compartmentOverview: CompartmentOverview;
  }): Observable<CompartmentOverview> {
    return this.http
      .withLoading()
      .post<CompartmentOverview>(
        `${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}`,
        compartmentOverview,
      );
  }

  deleteCompartment({ hubId, compartmentId }: { hubId: number; compartmentId: number }): Observable<void> {
    return this.http
      .withLoading()
      .delete<void>(`${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}/${compartmentId}`);
  }

  getNewSsccId({ hubId }: { hubId: number }): Observable<number> {
    return this.http
      .withLoading()
      .get<number>(`${API_URL}${HubEndpoint.Base}/${hubId}${CompartmentEndpoint.Base}${CompartmentEndpoint.SsccId}`, {
        responseType: 'text',
      });
  }
}
